export default "__VITE_ASSET__86d6a0c5__"